import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';
import BoxEmployee from '../BoxEmployee';
import {
  Geo,
  Chat,
  Phone,
  Envios,
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
  Vimeo,
  Pencil
} from '../../../../assets/images/index';

import {
  LineUserContact,
  WrapperInfoUser,
  InfoLineUser,
  WrapperSocial,
  ItemsSocial,
  ItemContact,
  IconContact,
  LinksSocialNetwork,
  StyleEditIcon,
  StyledDiv,
  StyledLink
} from './style';

const UserContact = ({ dataUser, dataSocial, onEditMode, onClick }) => {
  const { extension, corporatePhone, address, email } = dataUser;
  return (
    <StyledDiv>
      <BoxEmployee title="Estamos en contacto">
        {onEditMode && (
          <StyleEditIcon
            svg={Pencil}
            size="m"
            color="dark"
            onClick={onClick}
            hover
          />
        )}
        <WrapperInfoUser>
          {(extension || corporatePhone) && (
            <LineUserContact>
              <Icon svg={Phone} size="m" />
              <InfoLineUser>
                {extension && <span>{extension}</span>}
                {extension && corporatePhone && ' | '}
                {corporatePhone && <span>{corporatePhone}</span>}
              </InfoLineUser>
            </LineUserContact>
          )}
          {address && (
            <LineUserContact>
              <Icon svg={Geo} size="m" />
              <InfoLineUser>{address}</InfoLineUser>
            </LineUserContact>
          )}
        </WrapperInfoUser>
        <WrapperSocial>
          {dataSocial && (
            <ItemsSocial>
              {dataSocial.facebook && (
                <LinksSocialNetwork
                  href={`http://facebook.com/${dataSocial.facebook}`}
                  target="_blank"
                  title="Compartir en facebook. Abre en ventana nueva"
                >
                  <Icon svg={Facebook} size="m" hover />
                </LinksSocialNetwork>
              )}
              {dataSocial.twitter && (
                <LinksSocialNetwork
                  href={`https://twitter.com/${dataSocial.twitter}`}
                  target="_blank"
                  title="Compartir en tiwitter. Abre en ventana nueva"
                >
                  <Icon svg={Twitter} size="m" hover />
                </LinksSocialNetwork>
              )}
              {dataSocial.linkedin && (
                <LinksSocialNetwork
                  href={`https://linkedin.com/${dataSocial.linkedin}`}
                  target="_blank"
                  title="Compartir en linkedin. Abre en ventana nueva"
                >
                  <Icon svg={Linkedin} size="m" hover />
                </LinksSocialNetwork>
              )}
              {dataSocial.instagram && (
                <LinksSocialNetwork
                  href={`https://www.instagram.com/?hl=es/${dataSocial.instagram}`}
                  target="_blank"
                  title="Compartir en instagram. Abre en ventana nueva"
                >
                  <Icon svg={Instagram} size="m" hover />
                </LinksSocialNetwork>
              )}
              {dataSocial.vimeo && (
                <LinksSocialNetwork
                  href={`https://vimeo.com/es/${dataSocial.vimeo}`}
                  target="_blank"
                  title="Compartir en vimeo. Abre en ventana nueva"
                >
                  <Icon svg={Vimeo} size="m" hover />
                </LinksSocialNetwork>
              )}
            </ItemsSocial>
          )}
          {email && (
            <ItemContact>
              <StyledLink
                href={`https://outlook.office.com/owa/?path=/mail/action/compose&to=${email}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconContact color="primary" svg={Envios} size="l" />
              </StyledLink>
              <StyledLink
                href={`https://teams.microsoft.com/l/chat/0/0?users=${email}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconContact color="primary" svg={Chat} size="l" />
              </StyledLink>
            </ItemContact>
          )}
        </WrapperSocial>
      </BoxEmployee>
    </StyledDiv>
  );
};

UserContact.propTypes = {
  dataUser: PropTypes.shape({
    extension: PropTypes.number,
    mobile: PropTypes.string,
    address: PropTypes.string
  }),
  dataSocial: PropTypes.shape({
    facebook: PropTypes.string,
    instagram: PropTypes.string,
    twitter: PropTypes.string,
    vimeo: PropTypes.string,
    linkedin: PropTypes.string
  }),
  onClick: PropTypes.func,
  onEditMode: PropTypes.bool
};

export default UserContact;
